<template>
  <div class="exclusiveBill">
    <el-form label-width="6em" :model="searchForm" ref="searchForm" class="search-form">
      <el-row>
        <el-col :span="6">
          <el-form-item prop="periodMonth" label="账期">
            <el-date-picker
              v-model="searchForm.periodMonth"
              type="month"
              :clearable="false"
              value-format="yyyy-MM"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6" class="align-r">
          <el-button type="primary" @click="getTableData('query')" :loading="isLoading"
            >查询</el-button
          >
          <el-button
            :loading="isDownLoadingData"
            @click="
              exportData('reconcileBill_changChunExport', { ...searchForm, type: getBillType })
            "
            >导出</el-button
          >
        </el-col>
      </el-row>
    </el-form>
    <el-tabs v-model="activeName">
      <el-tab-pane label="日账单" name="first">
        <el-table v-loading="isLoading" :data="tableData_tab1">
          <el-table-column
            v-for="(item, i) in tableCols_tab1"
            :key="i"
            :width="item.width"
            :prop="item.prop"
            :label="item.label"
          />
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="月账单" name="second">
        <el-table v-loading="isLoading" :data="tableData_tab2">
          <el-table-column
            v-for="(item, i) in tableCols_tab2"
            :key="i"
            :width="item.width"
            :prop="item.prop"
            :label="item.label"
          />
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <div class="paging-wrapper" v-if="totalPages > 1 && activeName === 'first'">
      <el-pagination
        @current-change="handlePageNoChange"
        :current-page.sync="pageNo"
        :page-size="pageSize"
        layout="prev, pager, next, slot, jumper"
        :total="totalAmount"
      >
        <span class="page-indicator"
          ><em>{{ pageNo }}</em
          >/{{ totalPages }}</span
        >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { pagination } from '@/mixins'
import { getCurMonthStr } from '@/utils/calAccountPeriod'

export default {
  name: 'exclusiveBill',
  components: {},
  props: [],
  mixins: [pagination],
  data() {
    return {
      tableCols_tab1: [
        {
          label: '业务线',
          prop: 'businessLineStr',
          width: '',
        },
        {
          label: '日期',
          prop: 'bikeDay',
          width: '150',
        },
        {
          label: '账期',
          prop: 'periodMonth',
          width: '150',
        },
        {
          label: '供应商名称',
          prop: 'partnerName',
          width: '150',
        },
        {
          label: '城市',
          prop: 'region',
          // width: '120'
        },
        {
          label: '当日订单',
          prop: 'apployNum',
          width: '100',
        },
        {
          label: '单日收入(元)',
          prop: 'amount',
          width: '150',
        },
        {
          label: '分成比例',
          prop: 'rate',
          width: '150',
        },
        {
          label: '分成金额(元)',
          prop: 'rateAmount',
          width: '150',
        },
      ],
      tableCols_tab2: [
        {
          label: '业务线',
          prop: 'businessLineStr',
          width: '',
        },
        {
          label: '账期',
          prop: 'periodMonth',
          width: '',
        },
        {
          label: '供应商名称',
          prop: 'partnerName',
          width: '150',
        },
        {
          label: '城市',
          prop: 'region',
          width: '150',
        },
        {
          label: '订单',
          prop: 'apployNum',
          // width: '120'
        },
        {
          label: '收入(元)',
          prop: 'amount',
          width: '100',
        },
        {
          label: '分成比例',
          prop: 'rate',
          width: '150',
        },
        {
          label: '分成金额(元)',
          prop: 'rateAmount',
          width: '150',
        },
      ],
      isLoading: false,
      activeName: 'first',
      tableData_tab1: [],
      tableData_tab2: [],
      searchForm: {
        periodMonth: getCurMonthStr(),
      },
      isDownLoadingData: false,
    }
  },
  computed: {
    getBillType() {
      return this.activeName === 'first' ? 'day' : 'month'
    },
  },
  created() {
    this.init()
  },
  mounted() {},
  watch: {},
  methods: {
    async init() {
      this.pageSize = 10
      this.initPagination('getTableData', true)
      this.$debugVue('v_exclusiveBill', this)
    },
    async getTableData(type) {
      try {
        this.isLoading = true
        type === 'query' && (this.pageNo = 1)
        const params1 = {
          pageNumber: this.pageNo,
          pageSize: this.pageSize,
          ...this.searchForm,
          type: 'day',
        }
        const res = await this.fetch.get('reconcileBill_changChunList', { params: params1 })
        const { list, total } = res.data
        this.tableData_tab1 = list
        this.totalAmount = total

        const params2 = {
          ...this.searchForm,
          type: 'month',
        }
        const res2 = await this.fetch.get('reconcileBill_changChunList', { params: params2 })
        const { list: list2 } = res2.data
        this.tableData_tab2 = list2

        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        console.log('getTableData异常 ', e)
      }
    },
    exportData(api, params) {
      this.isDownLoadingData = true
      this.fetch
        .get(api, {
          params,
        })
        .then(res => {
          this.isDownLoadingData = false
          if (res.data) {
            window.open(res.data)
          } else {
            this.$message.error('数据错误，请重试')
          }
        })
        .catch(() => {
          this.isDownLoadingData = false
        })
    },
  },
}
</script>
